// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"fb2f61b2","496":"8d8889c6","647":"dc4ca74d"}[chunkId] + ".chunk.js";
};